module.exports = __webpack_public_path__ + "static/homeBcg-9456262b3e17eb8f46cf897d88e37760.jpeg";